/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

$(document).ready(() => {

  // Hamburger Menu
  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
  });

  // Wrap each dropdown menu so it can be columnized
  $('.dropdown-menu').wrapInner('<nav class="navbar-submenu"></nav>');

  // Wrap each dropdown menu so it can be columnized
  $('.navbar-submenu').wrapInner('<div class="sub bg-white"></div>');

  // Prepend the dropdown menu's title (based on its parent item) to each menu
  $('.navbar-submenu').each(function() {
    var title = $(this).closest('.menu-item').find('.dropdown-toggle').attr('title');
    $(this).prepend('<div class="d-block d-md-none"><aside class="close-menu mb-3"><i class="fas fa-arrow-left"></i> <span class="pl-3">Back </span></aside><h6 class="dropdown-header"><span>' + title + '</span></h6></div>');
  });


  // body overflow Shown
  $('.navbar-collapse').on('shown.bs.collapse', function () {
    $('body').addClass('menu-open');
  })
  // Body overflow Hidden
  $('.navbar-collapse').on('hidden.bs.collapse', function () {
    $('body').removeClass('menu-open');
  })
  // CLose it on Mobile

  $('.navbar-collapse .dropdown-menu a').click(function () {
    $('.navbar-collapse').collapse('hide');
  });

  // Accordion icons
  $('.wp-block-create-block-accordion-heading button').prepend('<i class="fas fa-plus icon-collapsed"></i><i class="fas fa-minus icon-expanded"></i>');

  // External Link Icon
  $('a[href]').each(function() {
    var a = new RegExp('/' + window.location.host + '/');
    if(!a.test(this.href)) {
        $(this).append('<span class="external-link">&nbsp;<i class="fas fa-external-link-alt"></i><span>');
    }
 });

 // Achor placement Navigation

  $(function(){
    if( window.location.hash ) {
      var hash = window.location.hash.substring(1);
      if( $(`#${hash}`).length ) {
        $('html, body').animate({
            scrollTop: $(`#${hash}`).offset().top - 200}, 1500);
        // return false;
      }
    }
  });
  // Anchor Scroll Body Links
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 200}, 1500)
        return false;
      }
    }
  });

  // Resize logo on scroll
  $(document).on("scroll", function(){
    if ($(document).scrollTop() >= 80){
        $(".navbar-brand img").addClass("shrink");
    } else {
        $(".navbar-brand img").removeClass("shrink");
    }
  });

// Mobile Table Indicator
  // $('.wp-block-table').prepend('<i class="fas fa-chevron-right d-block d-md-none float-right text-secondary my-2"></i>');
  // $('.wp-block-table').prepend('<div class="table-container-fade"></div>');

// This is THE END
});

// FontAwesome Imports
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faChevronUp, faChevronLeft, faArrowLeft, faSearch, faPlus, faMinus, faPhone, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
library.add(faFacebook, faTwitter, faLinkedin, faChevronRight, faChevronUp, faChevronLeft, faSearch, faPlus, faMinus, faArrowLeft, faPhone, faExternalLinkAlt);

dom.watch();
